const state = {
  activityInfoList: [],
  activityInfoCount: [],
  activityInfoDetail: {},

}
const	getters = {

  getActivityInfoDetail: state => {
    return state.activityInfoDetail;
  },
  getActivityInfoList: state => {
    return state.activityInfoList;
  },

  getActivityInfoCount: state => {
    return [
      {
        name: `全部`,
        label: `全部 (${state.activityInfoCount.all_count || 0})`,
        value: state.activityInfoCount.all_count
      },
      {
        name: `待审批`,
        label: `待审批 (${state.activityInfoCount.w_count || 0})`,
        value: state.activityInfoCount.w_count
      },
      {
        name: `审批中`,
        label: `审批中 (${state.activityInfoCount.al_count || 0})`,
        value: state.activityInfoCount.al_count
      },
      {
        name: `已审批`,
        label: `已审批 (${state.activityInfoCount.ok_count || 0})`,
        value: state.activityInfoCount.ok_count
      },
    ];
  },
}
const	mutations = {
  getactivityinfolist(state, payload) {
    state.activityInfoList = payload;
  },
  getactivityinfocount(state, payload) {
    state.activityInfoCount = payload;
  },
  getactivityinfodetail(state, payload) {
    state.activityInfoDetail = payload;
  },

}
const	actions = {
  reqActivityInfoDetail( { commit }, params) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/findCampaignDetailById",
        method: "get",
        params: params,
      }).then(res => {
        commit('getactivityinfodetail', res.data);
        r(res.data);
      }).catch(() => {
        j();
      })
    })
  },

  reqActivityInfoList( { commit }, params ) {
    
    fetch({
      url: "hcm/campgign/findPageCampaigns",
      method: "get",
      params: params,
      noFormat: true,
      responseType: "text"
    }).then(res => {
      let result = JSON.parse(res);
      commit('getactivityinfolist', result.data);
    })
    
  },

  reqActivityInfoCount( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/findCamCountToCheck",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        commit('getactivityinfocount', result.data);
        r(result.data);
      }).catch(() => {
        j();
      })
    })
    
  },

  reqReApplyActivity( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/Reapply",
        method: "post",
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => {
        r(res);
      }).catch(() => {
        j();
      })
    })
    
  },
  

}

export default {
  state,
  getters,
  mutations,
  actions
}